import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchCustomizedTripsDtlbannersec } from "../services/CustomizedTripsDtlbannersec";

const CustomizedTripsDtlcoversdmenu = () => {
  const { id } = useParams();
  const [CustomizedTripsDtl, setCustomizedTripsDtl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchCustomizedTripsDtlbannersec(decodeURIComponent(id));

      if (res?.status && res?.data?.length > 0) {
        setCustomizedTripsDtl(res.data[0]);
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (!CustomizedTripsDtl) return <div>No data found</div>;

  // Split covered_place into array of destinations
  const destinations = CustomizedTripsDtl.covered_place
    ? CustomizedTripsDtl.covered_place
        .split(",")
        .map((place) => place.trim())
        .filter(Boolean)
    : [];

  return (

     <section id="overview" className="scroll-mt-28">
        <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
          <div className="p-4 md:p-6">
            <h2 className="text-lg md:text-2xl font-bold text-slate-900 mb-3 md:mb-4">
              About This Trip
            </h2>
            <p className="text-sm md:text-base text-slate-600 leading-relaxed whitespace-pre-line">
              {CustomizedTripsDtl.available_time
              ? CustomizedTripsDtl.available_time
                  .replace(/<li>/g, '• ')    // replace <li> with bullet
                  .replace(/<\/li>/g, '\n')
                  .replace(/<[^>]+>/g, '')
              : "No available information"}
            </p>
          </div>
        </div>
        <div className="rounded-lg border bg-card text-card-foreground shadow-sm mt-4 md:mt-6">
          <div className="p-4 md:p-6">
            <h3 className="font-bold text-base md:text-lg text-slate-900 mb-3 md:mb-4 flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-map-pin h-5 w-5 text-primary"
              >
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                <circle cx={12} cy={10} r={3} />
              </svg>
              Destinations Covered
            </h3>
             <div className="flex flex-wrap gap-2">
              <div className="flex flex-wrap gap-2">
                {destinations.map((place, index) => (
                  <div
                    key={index}
                    className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80 text-xs md:text-sm text-white"
                  >
                    {place}
                  </div>
                ))}
              </div>
          </div>
          </div>
        </div>

      </section>

  );
};

export default CustomizedTripsDtlcoversdmenu;
